/**
 * Created by yiren on 2019-08-30
 *
 */

import React from "react";
import style from "./style.css";
import { InputItem, Toast } from "antd-mobile";
import { contractCall } from "../config/api";
import BigNumber from "bignumber.js";
import {storeContractAddress, storeFromAddress,getContractAddress,getFromAddress} from "../tool/lstool";

export default class Contract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractAddress: getContractAddress(),
      info: "",
      from: getFromAddress()
    };
  }

  componentDidMount() {
    if (this.state.contractAddress && this.state.from) {
      this.getContractInfo()
    }
  }

  setContract = v => {
    this.setState({
      contractAddress: v
    });
  };

  setFrom = v => {
    this.setState({
      from: v
    });
  };

  confirmContract = () => {
    storeContractAddress(this.state.contractAddress);
    Toast.info('合约设置成功',1);
  }

  getContractCode= () => {
    window.open('https://github.com/AtlasProtocol/interactions/tree/develop/contracts/NAS/governance');
  }

  getHelp= () => {
    window.open('https://github.com/AtlasProtocol/AtlasProtocol.github.io');
  }

  async getContractInfo() {
    Toast.loading();
    storeFromAddress(this.state.from);
    try {
      let param = `{"from":"${this.state.from}","to":"${this.state.contractAddress}","value":"0","gasPrice":"20000000000","gasLimit":"2000000","contract":{"function":"getContractInfo","args":"[]"}}`;

      const data = await contractCall(JSON.parse(param));
      // let result = JSON.parse(JSON.parse(data));
      // if (result.result.result) {
      //   this.setState({
      //       info: result.result.result
      //   })
      // }
      let info = JSON.parse(data.result.result);
      let chairs = [];
      for (let index in info.chairGroup) {
        let str = info.chairGroup[index] + "\n";
        chairs.push(str);
      }

      let execs = [];
      for (let index in info.execGroup) {
        let str = info.execGroup[index] + "\n";
        execs.push(str);
      }

      this.setState({
        chairGroup: chairs,
        execGroup: execs,
        tokenContract: info.tokenContract
      });

      this.getBalance();
      console.log(info);
    } catch (e) {
      console.log(e);
    }
  }

  async getBalance() {
    console.log("BALANCE FUNCTION");
    try {
      let param = `{"from":"n1STxGuEZaneTtNiXoVLD8TdmSk48Erfvnd","to":"${this.state.tokenContract}","value":"0","gasPrice":"20000000000","gasLimit":"2000000","contract":{"function":"balanceOf","args":"[\\"${this.state.contractAddress}\\"]"}}`;
      console.log(param);
      const data = await contractCall(JSON.parse(param));
      let info = JSON.parse(data.result.result);
      console.log(info);
      let actual = new BigNumber(info);
      let unit = new BigNumber(1000000000000000000);
      let amount = actual.dividedBy(unit);
      this.setState({
        balance: info,
        actualBalance: amount.toString()
      });
      Toast.hide();
    } catch (e) {
      Toast.hide();
      console.log(e);
    }
  }

  render() {
    return (
      <div className={style.container}>
        <div className={style.headerContainer}>
          <h2>治理合约</h2>
          <div>
            <button
                className={style.genButton}
                onClick={this.getContractCode.bind(this)}
            >
              查看合约模板代码
            </button>
            <button
                className={style.genButton}
                onClick={this.getHelp.bind(this)}
            >
              使用帮助
            </button>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(0,0,0,0.6)"
          }}
        />

        <div className={style.inputContainer}>
          <span className={style.inputName}>合约地址</span>
          <InputItem
            placeholder="Contract Address"
            className={style.proposalInput}
            onChange={v => this.setContract(v)}
            value={this.state.contractAddress}
          />
        </div>

        <div>
          <button
            className={style.genButton}
            onClick={this.confirmContract.bind(this)}
          >
            设置治理合约
          </button>
        </div>

        <div className={style.inputContainer}>
          <span className={style.inputName}>From 地址</span>
          <InputItem
              placeholder="From Address"
              className={style.proposalInput}
              onChange={v => this.setFrom(v)}
              value={this.state.from}
          />
        </div>

        <div>
          <button
              className={style.genButton}
              onClick={this.getContractInfo.bind(this)}
          >
            设置From
          </button>
        </div>



        {this.state.tokenContract ? (
          <div>
            <p>合约状态</p>
            <div className={style.txContainer}>
              <p>Contract: {this.state.contractAddress}</p>
              <p>executors: {this.state.execGroup}</p>
              <p>chairs: {this.state.chairGroup}</p>
              <p>TokenContract: {this.state.tokenContract}</p>
              <p>
                Balance: {this.state.balance} ({this.state.actualBalance})
              </p>
            </div>
          </div>
        ) : (
          false
        )}
      </div>
    );
  }
}
